import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useColorPicker } from "../../hooks/useColorPicker.js";
import { Picker } from "./Picker.js";
function PickerRoot(props) {
  const { value, onChange: onColorPickerChange, onCommit, onCancel } = useColorPicker();
  const onChange = useCallback(
    (value2) => {
      onColorPickerChange(null, value2);
    },
    [onColorPickerChange]
  );
  return /* @__PURE__ */ jsx(Picker, { ...props, color: value, onCancel, onChange, onCommit });
}
export {
  PickerRoot
};
//# sourceMappingURL=PickerRoot.js.map
